import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { accessInputFromRedux } from '@/abilities/accessInput';
import { useAccessInputFromQuery } from '@/abilities/useAccessInputFromQuery';
import { companyDashboardAccess } from '@/abilities/companyDashboard/access';
import { currentCompanyIdSelector } from '@/domain/router/routerLeafSelectors';
import { companyRoleModificatorsSelector, companyRoleSelector } from '@/domain/env/sessionRoleSelectors';
import { useCompanyCapabilities } from '@/domain/companies/queries/capabilities';

export const useCompanyDashboardAccess = () => {
  const companyId = useSelector(currentCompanyIdSelector);
  const role = useSelector(companyRoleSelector);
  const roleModificators = useSelector(companyRoleModificatorsSelector);
  const capabilities = useAccessInputFromQuery(useCompanyCapabilities(companyId));
  return useMemo(
    () =>
      companyDashboardAccess({
        role: accessInputFromRedux(role),
        roleModificators: accessInputFromRedux(roleModificators),
        capabilities,
      }),
    [role, roleModificators, capabilities],
  );
};
